import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { BaseService } from '../core';
import {
  BuyerChangePasswordDto,
  BuyerCheckEmailDto,
  BuyerCompanyUpdateDto,
  Buyer,
  BuyerFindEmailDto,
  BuyerShippingAddressListDto,
  BuyerUpdateDto,
  Wallet,
  BuyerWithdraw,
  BuyerWithdrawDto,
  BuyerRestorationDormentDto,
} from '../dto';
import { BuyerShippingAddress } from '../dto/buyer/buyer-shipping-address.entity';
import { Auth } from '../shared';
import * as IndicatorStore from '../store/indicator';
@Injectable({
  providedIn: 'root',
})
export class BuyerService extends BaseService {
  constructor(private store: Store<any>) {
    super();
  }

  getBuyer() {
    return this.get<Buyer>('/buyer');
  }

  updateBuyer(buyerUpdateDto: BuyerUpdateDto) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('updateBuyer'));
    return this.put<Buyer>('/buyer', buyerUpdateDto).pipe(
      mergeMap((buyer) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('updateBuyer'));
        return of(buyer);
      })
    );
  }

  updateBuyerCompany(buyerCompanyUpdateDto: BuyerCompanyUpdateDto) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('updateBuyerCompany'));
    return this.put<Buyer>('/buyer/company', buyerCompanyUpdateDto).pipe(
      mergeMap((buyer) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('updateBuyerCompany'));
        return of(buyer);
      })
    );
  }

  cancelRequest() {
    return this.post<Buyer>('/buyer/cancel-request');
  }

  reRequest(buyer: BuyerUpdateDto) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('reRequest'));
    return this.post<Buyer>('/buyer/company/re-request', buyer).pipe(
      mergeMap((buyer) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('reRequest'));
        return of(buyer);
      })
    );
  }

  findEmail(buyerFindEmailDto: BuyerFindEmailDto) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('findEmail'));
    return this.post<Buyer>('/buyer/find-email', buyerFindEmailDto).pipe(
      mergeMap((buyer) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('findEmail'));
        return of(buyer);
      })
    );
  }

  checkEmail(body: BuyerCheckEmailDto) {
    return this.post<{ isUsable: boolean }>('/buyer/check-email', body);
  }

  changePassword(buyerChangePasswordDto: BuyerChangePasswordDto) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('changePassword'));
    return this.put<Buyer>('/buyer/change-password', buyerChangePasswordDto).pipe(
      mergeMap((buyer) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('changePassword'));
        return of(buyer);
      })
    );
  }

  validateByWithdraw() {
    return this.get<Wallet>('/buyer/withdraw/validate');
  }

  withdraw(buyerWithdrawDto: BuyerWithdrawDto) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('withdraw'));
    return this.delete<BuyerWithdraw>('/buyer', buyerWithdrawDto).pipe(
      mergeMap((buyerWithdraw) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('withdraw'));
        return of(buyerWithdraw);
      })
    );
  }

  restorationDorment(buyerRestorationDormentDto: BuyerRestorationDormentDto) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('restorationDorment'));
    return this.post<Auth>('/buyer/restoration', buyerRestorationDormentDto).pipe(
      mergeMap((buyer) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('restorationDorment'));
        return of(buyer);
      })
    );
  }

  // withdrawWaiting() {
  //   return this.delete<BuyerDto>('/buyer/waiting');
  // }

  getShipmentInfoAddress(buyerShippingAddressListDto: BuyerShippingAddressListDto) {
    return this.get<BuyerShippingAddress[]>('/buyer/shipping-address', buyerShippingAddressListDto);
  }

  addShipmentInfoAddress(shippingAdress: BuyerShippingAddress) {
    return this.post(`/buyer/shipping-address`, shippingAdress);
  }

  removeShipmentInfoAddress(id: number) {
    return this.delete(`/buyer/shipping-address/${id}`);
  }
}
